import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={24.915}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 69088 66974"
    {...props}
  >
    <defs>
      {/* <style>{".fil0{fill:#2b2a29}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m36667 42451 3028-3028 5481 5482-2776 2776c-1568-2078-3515-3855-5733-5230zM47182 63237h7076v-1992h7752v1992h7078v3737H47182zM55269 58997h5730v-4132h-5730zM56617 32724h3034v19892h-3034z"
        className="fill"
      />
      <path
        d="M40830 41100c1735-1572 3267-3288 4358-5099 1073-1780 1707-3641 1651-5519-100-3404-1943-5531-3828-7702-2532-2921-5122-5907-5122-11649 0-3073 1246-5856 3260-7871C43163 1246 45947 0 49021 0s5856 1247 7871 3260c2013 2015 3260 4798 3260 7871v19548h-4064V11131c0-1950-791-3718-2070-4997-1279-1280-3046-2070-4997-2070-1952 0-3720 791-4998 2070-1279 1279-2070 3047-2070 4997 0 4243 2084 6647 4122 8997 2359 2721 4670 5384 4813 10243 80 2730-773 5321-2223 7725-1271 2109-3011 4080-4969 5870l-2866-2866zM14085 52825c-1493-1493-3556-2417-5834-2417-2279 0-4341 924-5834 2417S0 56380 0 58658c0 2279 924 4342 2417 5835s3555 2416 5834 2416c2278 0 4341-923 5834-2416 1443-1445 2355-3421 2413-5610l1-11 1-64v-50l1-100v-80l-1-26c0-70-2-142-4-212v-3c-84-2151-989-4090-2411-5512zm2401 13065c1591-1810 2594-4150 2712-6721l2-42 2-66 1-9 3-99 1-50 2-89v-22l1-134c0-88-1-175-3-264l-1-18v-35l-2-51-1-12-3-94-3-53c-59-1258-331-2462-781-3574h5975c2696 0 5147 1104 6926 2882 1778 1778 2881 4230 2881 6925 0 406-162 791-449 1077-277 277-658 449-1077 449H16486zM8251 54455c2321 0 4203 1882 4203 4203 0 2322-1882 4205-4203 4205-2322-1-4204-1883-4204-4205 0-2321 1882-4203 4204-4203zm15844-13498c11492 0 20894 9404 20894 20896 0 2966-2426 5121-5391 5121h-3825c703-757 1135-1770 1135-2880 0-3344-1330-6224-3676-8571-2268-2268-5398-3675-8841-3675h-7554c-261-329-540-643-836-939-1984-1983-4724-3210-7750-3210-1962 0-3802 515-5395 1417 1990-4778 6716-8159 12192-8159h5v-2053h8334v2053h708z"
        className="fill"
      />
    </g>
  </svg>
)
export default SvgComponent
